"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../../shared/components/table_actions/TableActionDelete");
var WrapTableActions_1 = require("../../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var TableMenuIsLocked_1 = require("../../../../../../../shared/components/table_menus/TableMenuIsLocked");
var TableActionComment_1 = require("../../../../../../../shared/components/table_actions/TableActionComment");
var TableActionDetail_1 = require("../../../../../../../shared/components/table_actions/TableActionDetail");
var DropDownButtonCreate_1 = require("../../../../../../../shared/components/dropdown_buttons/DropDownButtonCreate");
var TableActionUser_1 = require("../../../../../../../shared/components/table_actions/TableActionUser");
var TableActionCalendar_1 = require("../../../../../../../shared/components/table_actions/TableActionCalendar");
var ButtonDoExportXLS_1 = require("../../../../../../../shared/components/buttons/ButtonDoExportXLS");
var PromoCodeTypeCodesList = /** @class */ (function (_super) {
    __extends(PromoCodeTypeCodesList, _super);
    function PromoCodeTypeCodesList(props) {
        var _this = _super.call(this, props) || this;
        _this.searchLoginInput = null;
        _this.searchEMailInput = null;
        return _this;
    }
    PromoCodeTypeCodesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            totalRows: 0,
        }, function () {
            _this.doReLoadPromoCodeList();
        });
        this.props.state.setExtBreadCrumbPath(["\u0421\u043F\u0438\u0441\u043E\u043A \u043A\u043E\u0434\u043E\u0432 - [" + this.props.record.description + "]"]);
    };
    PromoCodeTypeCodesList.prototype.doReLoadPromoCodeList = function () {
        this.props.data.LoadData(this.props.record.key);
    };
    PromoCodeTypeCodesList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    PromoCodeTypeCodesList.prototype.doLockUnLockAction = function (Key, Title, Lock) {
        this.props.data.SetIsLocked(Key, Lock, function () {
            if (Lock) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041F\u0440\u043E\u043C\u043E\u043A\u043E\u0434 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041F\u0440\u043E\u043C\u043E\u043A\u043E\u0434 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
        });
    };
    PromoCodeTypeCodesList.prototype.doReserveUnReserveAction = function (Key, Title, Lock) {
        this.props.data.SetIsReserved(Key, Lock, function () {
            if (Lock) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041F\u0440\u043E\u043C\u043E\u043A\u043E\u0434 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0437\u0430\u0440\u0435\u0437\u0435\u0440\u0432\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041F\u0440\u043E\u043C\u043E\u043A\u043E\u0434 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0441\u043D\u044F\u0442 \u0441 \u0440\u0435\u0437\u0435\u0440\u0432\u0430"));
            }
        });
    };
    PromoCodeTypeCodesList.prototype.bool2Str = function (val) {
        if (val) {
            return "ДА";
        }
        else {
            return "НЕТ";
        }
    };
    PromoCodeTypeCodesList.prototype.onClearLoginFilter = function () {
        this.setState({
            searchLoginFilter: [],
            searchLoginValue: "",
            isSearchLogin: false,
        });
    };
    PromoCodeTypeCodesList.prototype.onClearEMailFilter = function () {
        this.setState({
            searchEMailFilter: [],
            searchEMailValue: "",
            isSearchEmail: false
        });
    };
    PromoCodeTypeCodesList.prototype.onChangeLoginFilter = function (e) {
        this.setState({ searchLoginValue: e.target.value });
    };
    PromoCodeTypeCodesList.prototype.onChangeEMailFilter = function (e) {
        this.setState({ searchEMailValue: e.target.value });
    };
    PromoCodeTypeCodesList.prototype.onConfirmLoginFilter = function () {
        this.setState({
            searchLoginFilter: [this.state.searchLoginValue],
            isSearchLogin: true
        });
    };
    PromoCodeTypeCodesList.prototype.onConfirmEMailFilter = function () {
        this.setState({
            searchEMailFilter: [this.state.searchEMailValue],
            isSearchEmail: true
        });
    };
    PromoCodeTypeCodesList.prototype.doAddZero = function (val) {
        if (val < 10) {
            return "0" + val;
        }
        else {
            return "" + val;
        }
    };
    PromoCodeTypeCodesList.prototype.getColumns = function () {
        var _this = this;
        var _login_filter = this.state.searchLoginFilter;
        var _email_filter = this.state.searchEMailFilter;
        return ([{
                title: 'Промокод',
                dataIndex: this.props.data.dk_promo_code,
                key: this.props.data.dk_promo_code,
                width: 250,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchLoginInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043F\u0440\u043E\u043C\u043E\u043A\u043E\u0434\u0443", value: _this.state.searchLoginValue, onChange: _this.onChangeLoginFilter.bind(_this), onPressEnter: function () { _this.onConfirmLoginFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmLoginFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearLoginFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _login_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.promo_code.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchLoginInput.focus();
                        });
                    }
                }
            }, {
                title: 'Партнер',
                dataIndex: this.props.data.dk_pprogram_title,
                key: this.props.data.dk_pprogram_title,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.partner_login));
                },
            }, {
                title: 'Кол-во активаций',
                dataIndex: this.props.data.dk_activated_count,
                key: this.props.data.dk_activated_count,
                width: 120,
                sorter: function (a, b) { return a.activated_count - b.activated_count; },
            }, {
                title: 'Использован',
                dataIndex: this.props.data.dk_is_used,
                key: this.props.data.dk_is_used,
                width: 120,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement("div", null, _this.bool2Str(record.is_used)));
                },
                filters: [
                    { text: "Использован", value: 'true' },
                    { text: "Доступен", value: 'false' },
                ],
                filterMultiple: false,
                onFilter: function (value, record) { return record.is_used === (value === 'true'); }
            }, {
                title: 'Зерезервирован',
                dataIndex: this.props.data.dk_is_reserved,
                key: this.props.data.dk_is_reserved,
                align: "center",
                render: function (text, record, idx) {
                    if (record.is_used) {
                        return (React.createElement("div", null,
                            _this.bool2Str(record.is_reserved),
                            "/(\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D)"));
                    }
                    else {
                        return (React.createElement(TableMenuIsLocked_1.default, { lockedTexts: { menu: "Зарезервировать промокод", text: "Да" }, unlockedTexts: { menu: "Снять с резерва промокод", text: "Нет" }, record: { key: record.key, title: record.promo_code, locked: record.is_reserved }, onLockClick: _this.doReserveUnReserveAction.bind(_this) }));
                    }
                },
                width: 120,
                filters: [
                    { text: "Зарезервирован", value: 'true' },
                    { text: "Доступен", value: 'false' },
                ],
                filterMultiple: false,
                onFilter: function (value, record) { return record.is_reserved === (value === 'true'); }
            }, {
                title: 'Заблокирован',
                dataIndex: this.props.data.dk_is_locked,
                key: this.props.data.dk_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    if (record.is_used) {
                        return (React.createElement("div", null,
                            _this.bool2Str(record.is_locked),
                            "/(\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D)"));
                    }
                    else {
                        return (React.createElement(TableMenuIsLocked_1.default, { lockedTexts: { menu: "Заблокировать промокод", text: "Да" }, unlockedTexts: { menu: "Разблокировать промокод", text: "Нет" }, record: { key: record.key, title: record.promo_code, locked: record.is_locked }, onLockClick: _this.doLockUnLockAction.bind(_this) }));
                    }
                },
                width: 120,
                filters: [
                    { text: "Заблокирован", value: 'true' },
                    { text: "Доступен", value: 'false' },
                ],
                filterMultiple: false,
                onFilter: function (value, record) { return record.is_locked === (value === 'true'); }
            }, {
                title: 'Срок действия',
                dataIndex: this.props.data.dk_is_can_expire,
                key: this.props.data.dk_pprogram_title,
                width: 150,
                render: function (text, record, idx) {
                    if (!record.is_can_expire) {
                        return (React.createElement("div", null, "\u041D\u0415\u0422"));
                    }
                    else {
                        return (React.createElement("div", null,
                            "\u0414\u041E ",
                            React.createElement("b", null,
                                record.expire_year,
                                ".",
                                _this.doAddZero(record.expire_month),
                                ".",
                                _this.doAddZero(record.expire_day)),
                            " \u0412\u041A\u041B. "));
                    }
                },
            }, {
                title: 'Комментарий',
                dataIndex: this.props.data.dk_description,
                key: this.props.data.dk_description,
                width: 200,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchEMailInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u044E", value: _this.state.searchEMailValue, onChange: _this.onChangeEMailFilter.bind(_this), onPressEnter: function () { _this.onConfirmEMailFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmEMailFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearEMailFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _email_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.description.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchEMailInput.focus();
                        });
                    }
                }
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionDetail_1.default, { hint: "\u041B\u043E\u0433\u0438 \u0430\u043A\u0438\u0432\u0430\u0446\u0438\u0439", onClick: function () { _this.onViewLogsClick(record); } }),
                    React.createElement(TableActionComment_1.default, { hint: "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439", onClick: function () { _this.onCommentClick(record); } }),
                    React.createElement(TableActionUser_1.default, { hint: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430", onClick: function () { _this.onChangeOwnerClick(record); } }),
                    React.createElement(TableActionCalendar_1.default, { hint: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0440\u043E\u043A \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F", onClick: function () { _this.onChangeExpirationClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 150
            }
        ]);
    };
    PromoCodeTypeCodesList.prototype.onViewLogsClick = function (record) {
        if (this.props.onViewLogsClick) {
            this.props.onViewLogsClick(record);
        }
    };
    PromoCodeTypeCodesList.prototype.onCommentClick = function (record) {
        var _this = this;
        this.props.dlgDescriptionEditor.SetTitle("Изменить описание").SetDescription(record.description).SetOnYesClick(function (description) {
            _this.props.data.SetDescription(record.key, description, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043F\u0440\u043E\u043C\u043E\u043A\u043E\u0434\u0430 ",
                    React.createElement("b", null,
                        "[",
                        record.promo_code,
                        "]"),
                    " \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u043E"));
            });
        }).Show();
    };
    PromoCodeTypeCodesList.prototype.onChangeExpirationClick = function (record) {
        var _this = this;
        if (record.expire_year > 0) {
            this.props.dlgPromoCodeExpiration.SetYear(record.expire_year);
        }
        if (record.expire_month > 0) {
            this.props.dlgPromoCodeExpiration.SetMonth(record.expire_month);
        }
        if (record.expire_day > 0) {
            this.props.dlgPromoCodeExpiration.SetDay(record.expire_day);
        }
        this.props.dlgPromoCodeExpiration.SetIsExpire(record.is_can_expire);
        this.props.dlgPromoCodeExpiration.SetTitle("Утановить срок действия").SetOnYesClick(function (IsExpire, Year, Month, Day) {
            _this.props.data.SetExpirationParams(record.key, IsExpire, Year, Month, Day, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0421\u0440\u043E\u043A \u0434\u0435\u0439\u0442\u0441\u0432\u0438\u044F \u043F\u0440\u043E\u043C\u043E\u043A\u043E\u0434\u0430 ",
                    React.createElement("b", null,
                        "[",
                        record.promo_code,
                        "]"),
                    " \u0431\u044B\u043B \u0438\u0437\u043C\u0435\u043D\u0435\u043D!"));
            });
        }).Show();
    };
    PromoCodeTypeCodesList.prototype.onChangeOwnerClick = function (record) {
        var _this = this;
        this.props.dialogSetPromoPartner.SetDialogTitle("Изменить партнера").SetOnYesClick(function (pprogram, partner, offer) {
            _this.props.data.SetPartner(record.key, pprogram, partner, offer, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041F\u0430\u0440\u0442\u043D\u0435\u0440 \u043F\u0440\u043E\u043C\u043E\u043A\u043E\u0434\u0430 ",
                    React.createElement("b", null,
                        "[",
                        record.promo_code,
                        "]"),
                    " \u0431\u044B\u043B \u0438\u0437\u043C\u0435\u043D\u0435\u043D!"));
            });
        }).Show();
    };
    PromoCodeTypeCodesList.prototype.onDeleteClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u041F\u0440\u043E\u043C\u043E\u043A\u043E\u0434 ",
                React.createElement("b", null,
                    "[",
                    record.promo_code,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    PromoCodeTypeCodesList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.record.key);
        }
        /*if (action === "create") {
            this.props.dlgGeneratePromoCode.SetTitle("Генерация промокодов").SetOnYesClick((count, description) => {
                this.props.data.DoGeneratePromoCodes(
                    this.props.record.key,
                    count,
                    description,
                    () => {
                        this.props.data.LoadData(this.props.record.key, () => {
                            this.props.dlgGeneratePromoCode.Close();
                            notificationHelper.ShowTopRightNotification(<div>Промокоды в количестве <b>[{count}]</b> были успешно созданы</div>);
                        })
                    })
            }).SetPromoTypeTitle(this.props.record.title).Show();
        }*/
        if (action == "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    PromoCodeTypeCodesList.prototype.doGenPromoCode = function (key) {
        var _this = this;
        if (key === 0) { //by prefix
            this.props.dlgGeneratePromoCode.SetTitle("Генерация нескольких промокодов").SetOnYesClick(function (Count, Description, IsBindPartner, PProgram, Partner, Offer) {
                _this.props.data.DoGeneratePromoCodes({
                    dscription: Description,
                    generateCount: Count,
                    isBindPartner: IsBindPartner,
                    partnerOfferId: Offer,
                    pprogramId: PProgram,
                    promoCodeTemplateId: _this.props.record.key,
                    usrPartnerId: Partner
                }, function () {
                    _this.props.data.LoadData(_this.props.record.key, function () {
                        _this.props.dlgGeneratePromoCode.Close();
                        notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                            "\u041F\u0440\u043E\u043C\u043E\u043A\u043E\u0434\u044B \u0432 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0435 ",
                            React.createElement("b", null,
                                "[",
                                Count,
                                "]"),
                            " \u0431\u044B\u043B\u0438 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u043D\u044B"));
                    });
                });
            }).SetPromoTypeTitle(this.props.record.title).Show();
        }
        if (key === 1) {
            this.props.glgGenerateOnePromoCode.SetTitle("Создание уникального промокодов").SetOnYesClick(function (code, description) {
                _this.props.data.DoGenerateOnePromoCode(_this.props.record.key, code, description, function () {
                    _this.props.data.LoadData(_this.props.record.key, function () {
                        _this.props.glgGenerateOnePromoCode.Close();
                        notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                            "\u041F\u0440\u043E\u043C\u043E\u043A\u043E\u0434 ",
                            React.createElement("b", null,
                                "[",
                                code,
                                "]"),
                            " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u043D!"));
                    });
                });
            }).SetPromoTypeTitle(this.props.record.title).Show();
        }
    };
    PromoCodeTypeCodesList.prototype.doExportAllPlayers = function () {
        var _this = this;
        this.props.dlgExport
            .clearFields()
            .SetDialogTitle("Экспорт списка промокодов")
            .SetOnYesClick(function (exportFormat) {
            _this.props.data.ExportData(_this.props.record.key, function (data) {
                if (exportFormat === "XLSX") {
                    var opts = [{ sheetid: 'All Promocodes list', header: true }];
                    var result = alasql('SELECT * INTO XLSX("exported_codes_list.xlsx",?) FROM ?', [opts, [data]]);
                }
                if (exportFormat === "CSV") {
                    var result = alasql('SELECT * INTO CSV("exported_codes_list.csv", {headers:true}) FROM ?', [data]);
                }
                if (exportFormat === "JSON") {
                    var result = alasql('SELECT * INTO JSON("exported_codes_list.json", {headers:false}) FROM ?', [data]);
                }
                if (exportFormat === "TXT") {
                    var result = alasql('SELECT * INTO TAB("exported_codes_list.txt", {headers:true}) FROM ?', [data]);
                }
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u042D\u043A\u0441\u043F\u043E\u0440\u0442 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 ",
                    React.createElement("b", null,
                        "[",
                        exportFormat,
                        "]"),
                    " \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D !"));
            });
        }).Show();
    };
    PromoCodeTypeCodesList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { back: "Назад", refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ButtonDoExportXLS_1.default, { hint: "Экспорт списка кодов", onClick: function () { _this.doExportAllPlayers(); } }),
                React.createElement(DropDownButtonCreate_1.default, { hint: "Сгенерировать", onItemClick: this.doGenPromoCode.bind(this), title: "Сгенерировать", items: [
                        { key: 0, value: "Несколько с префиксом", icon: "sync", separatorAfter: true },
                        { key: 1, value: "Один уникальный", icon: "sync" },
                    ] })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, pagination: {
                    pageSize: this.props.state.UITablePageSize,
                    showSizeChanger: true,
                    total: this.state.totalRows,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added2.format(_this.props.state.getDateTimeFormat()),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                            " [",
                            record.date_changed2.format(_this.props.state.getDateTimeFormat()),
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "***************************************")),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041F.\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430:"),
                            " [",
                            record.pprogram_title,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041F\u0430\u0440\u0442\u043D\u0435\u0440:"),
                            " [",
                            record.partner_login,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041E\u0444\u0444\u0435\u0440:"),
                            " [",
                            record.offer_title,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0422\u0440\u0435\u043A\u0435\u0440:"),
                            " [",
                            record.tracker_title,
                            "]")));
                }, scroll: { x: true } })));
    };
    return PromoCodeTypeCodesList;
}(React.Component));
exports.default = PromoCodeTypeCodesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_promocodes/ui/component/codes/PromoCodeTemplateCodesList.tsx
// module id = 1970
// module chunks = 0